import { render, staticRenderFns } from "./LiveEdit.vue?vue&type=template&id=d82b54b4&scoped=true&"
import script from "./LiveEdit.vue?vue&type=script&lang=js&"
export * from "./LiveEdit.vue?vue&type=script&lang=js&"
import style0 from "./LiveEdit.vue?vue&type=style&index=0&id=d82b54b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82b54b4",
  null
  
)

export default component.exports